<template>
  <div class="picmanger">
    <div class="rightmouse"
         :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px' ,opacity : rightMouseFlag ? '1' : '0'}">
      <p>© 图片版权保护</p>
    </div>
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作流</el-breadcrumb-item>
          <el-breadcrumb-item>栏目审核</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main"
         v-loading="isRefresh">
      <div class="head">
        <h4>栏目征稿</h4>
        <!-- <p>+新增用户</p> -->
      </div>

      <div class="search">
        <!-- 征稿活动 -->
        <p style="margin-right:15px;">栏目标题:</p>
        <!-- 征稿活动 -->
        <el-select v-model="activity"
                   style="width:8%"
                   filterable
                   @clear="clearInput"
                   :clearable="true"
                   placeholder="不限">
          <el-option v-for="item in columnNameArr"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id"
                     v-html="'<span style=color:#303030;>'+item.name+'</span>'"></el-option>
        </el-select>

        <div class="selectClass">
          <!-- 审核 -->
          <p style="margin: 0 15px;">审核:</p>
          <!-- 审核 -->
          <el-select v-model="isCheck"
                     size="mini"
                     filterable
                     clearable
                     placeholder="不限">
            <el-option v-for="item in isCheckList"
                       :key="item.value + '-2'"
                       :label="item.label"
                       :value="item.value"
                       v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
          </el-select>
          <p style="margin: 0 15px;">角色筛选:</p>
          <!-- 角色筛选 -->
          <el-select size="mini"
                     v-model="isCheckAuthor">
            <el-option v-for="item in [{name:'不限',value:-1},{name:'未认证',value:0},{name:'已认证',value:1}]"
                       :key="item.value + '-2'"
                       :label="item.name"
                       :value="item.value"></el-option>
          </el-select>

          <p style="margin: 0 15px;">发布状态:</p>
          <!-- 发布状态 -->
          <el-select size="mini"
                     v-model="isCheckStatus">
            <el-option v-for="item in [{name:'不限',value:-1},{name:'未发布',value:0},{name:'已发布',value:1}]"
                       :key="item.value + '-3'"
                       :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </div>

        <!-- 状态 -->
        <!-- <p style="margin: 0 15px;">状态:</p>

        <el-select v-model="status" filterable placeholder="不限">
          <el-option
            v-for="item in statusList"
            :key="item.value + '-1'"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select> -->

        <!-- 入库时间 -->
        <!-- <p>入库时间:</p>
        <el-date-picker
          v-model="warehousingTime"
          type="daterange"
          align="center"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>-->

        <el-button @click="searchClick"
                   :style="{'margin':'0 15px','backgroundColor': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}"
                   class="btn">搜索</el-button>
        <p>共收集{{totals||0}}张图片</p>
        <div style="marginLeft:60px;fontSize:14px;">
          <span>已选中{{selectActList.length || 0}}篇</span>
          <el-button @click="batchRelease"
                   :style="{width:'90px','margin':'0 15px','backgroundColor': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}"
                   class="btn">批量发布</el-button>
        </div>
        <div class="choosepicselect">
          <el-dropdown @command="handleCommand">
            <div class="el-dropdown-link mychoose">
              <img src="@/assets/solicitationactivities/folder.png"
                   alt="">
              已选中{{choosePicList.length}}张
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </div>
            <el-dropdown-menu style="width:190px;"
                              slot="dropdown">
              <el-dropdown-item command="a">创建图集</el-dropdown-item>
              <el-dropdown-item command="b">加入图集</el-dropdown-item>
              <el-dropdown-item v-if="choosePicList.length > 0"
                                command="c">查看图片</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="bigbj"
           style="margin-bottom: 100px;">
        <div class="tablebg"
             v-for="(e,i) in listPictureActivity"
             :key="i">
          <div class="head disflex">
            <div class="left disflex">
              <img @click.stop="selectAct(e,i)" :src="e.isSelect ? require('@/assets/mobilePage/checktrue.png') : require('@/assets/mobilePage/checkfalse.png')" width="16px" height="16px" style="marginRight:10px;cursor: pointer;" alt="">
              <div>{{e.createAtMy}}</div>
              <div style="margin-left:25px;font-size:17px;font-weight:bold;color:rgba(51,51,51,1);white-space: nowrap;"
                   :title="e.title">{{e.title.length > 8  ? e.title.slice(0,8) + '...' : e.title}}</div>
              <div style="font-size:12px; margin-left:50px;"
                   :title="e.actName"> <span style="font-weight:bolder;">栏目名：</span> {{(e.columnInfo.name) || '暂无'}}</div>
              <div style="font-size:12px; margin-left:26px;display: flex;justify-content: center;align-items: center;">
                <span style="font-weight:bolder;">投稿人：</span>

                <el-popover placement="right"
                            title="基本信息"
                            width="200"
                            trigger="click">
                  <p v-if="userInfo.realName"
                     class="tipck">真实姓名：{{userInfo.realName}}</p>
                  <p v-else
                     class="tipck">昵称：{{userInfo.name}}</p>
                  <p class="tipck">手机号：{{userInfo.mobile}}</p>
                  <p class="tipck">邮箱：{{userInfo.email}}</p>
                  <span @click="seeInfoClick(e.createUserInfo.id)"
                        style="color:#185ED3;cursor: pointer;"
                        slot="reference">{{e.actUser || '暂无'}}</span>
                </el-popover>

                <img v-if="e.createUserInfo.authStatus == 1"
                     style="margin-left:4px;"
                     src="@/assets/solicitationactivities/auth.png"
                     alt="">
              </div>
              <div style="font-size:12px; margin-left:26px;"> <span style="font-weight:bolder;">图片张数：</span> {{e.pictureInfo.length || '0'}}张</div>
            </div>
            <div class="right disflex">
              <div style="background: #6DD019;"
                   v-if="e.isCheck !== 2 && (e.websiteShowInfoList == null? true : e.websiteShowInfoList.length == 0)"
                   @click="publishing(e)">
                <img width="20px"
                     src="@/assets/solicitationactivities/publicshed.png"
                     alt="">
                <div>一键发布</div>
              </div>
              <div style="background: #FF9315;"
                   v-if="e.isCheck !== 2 && e.websiteShowInfoList != null && e.websiteShowInfoList.length > 0"
                   @click="publishing(e)">
                <img width="20px"
                     src="@/assets/solicitationactivities/publicshed.png"
                     alt="">
                <div>再次发布</div>
              </div>
              <div style="background: #185ED3;"
                   @click="seeInf(e)">
                <img src="@/assets/solicitationactivities/see.png"
                     alt="">
                <div>查看内容</div>
              </div>
              <div style="background: #AF2B27;"
                   v-if="e.isCheck === 2"
                   @click="getReasonAsync(e)">
                <img src="@/assets/solicitationactivities/refuseReason.png"
                     alt="">
                <div>拒绝理由</div>
              </div>
              <div style="background: #00BAFF;"
                   @click="checkClicksh(e.id)"
                   v-if="e.isCheck === 0">
                <img src="@/assets/solicitationactivities/check.png"
                     alt="">
                <div>通过</div>
              </div>
              <div style="background: #FF5105;"
                   @click="checkClickrefuse(e)"
                   v-if="e.isCheck === 0 || e.isCheck === 1">
                <img src="@/assets/solicitationactivities/discheck.png"
                     alt="">
                <div>拒绝</div>
              </div>
              <!-- <div style="background: #FF5105;" @click="checkClickfs(e.id)" v-if="e.isCheck === 1">
                <img src="@/assets/solicitationactivities/discheck.png" alt=""><div>反审</div>
              </div> -->
              <div style="background: #FF8C05;"
                   @click="putIn(e)"
                   v-if="e.status !== 1 && e.isCheck === 1 && e.videosIds == ''">
                <img src="@/assets/solicitationactivities/add.png"
                     alt="">
                <div>创建图集</div>
              </div>
              <div style="background: #00BB1A;"
                   @click="addIn(e)"
                   v-if="e.status !== 1 && e.isCheck === 1 && e.videosIds == ''">
                <img src="@/assets/solicitationactivities/goin.png"
                     alt="">
                <div>加入图集</div>
              </div>
              <div style="background: #00C590;"
                   @click="useGao(e)"
                   v-if="e.isCheck === 1 && e.videosIds == ''">
                <img src="@/assets/solicitationactivities/edit.png"
                     alt="">
                <div>用稿</div>
              </div>
            </div>
          </div>

          <div :ref="'tablebgbody' + i"
               v-if="e.videosIds == ''"
               class="tablebgbody">
            <div @click="actLeft(i)"
                 v-if="e.pictureCount > 7"
                 class="left">
              <img src="@/assets/picbrowse/leftjt.png"
                   width="20px"
                   alt />
            </div>

            <div :ref="'actimg' + i"
                 class="actimg">
              <div class="imgs"
                   @click="e.isCheck === 1 && ce.atlasId === 0 && openDialog(ci,ce,e,i)"
                   v-for="(ce,ci) in e.pictureInfo"
                   :key="ci">
                <img :src="ce.fileInfo.scr"
                     @contextmenu.prevent="rightShow($event)"
                     ondragstart="return false;"
                     :title="ce.id"
                     height="110px"
                     alt />

                <div class="dian">
                  <img src="@/assets/piclist/dian.png" alt="">
                  <div class="diannr">
                    <p @click.stop="seePic(ci,ce,e,i)">查看图片</p>
                    <p v-if="e.isCheck === 1 && ce.atlasId === 0" @click.stop="openChangeDesc(ce)">修改图片说明</p>
                  </div>
                </div>
                <!-- <div>{{e.publishedArr?e.publishedArr[ci]:'暂无'}}{{ci}}</div> -->
                <!-- 已发布图片信息 -->
                <div v-if="e.websiteShowInfoList != null  && e.websiteShowInfoList.length">
                  <el-tooltip class="item"
                              effect="dark"
                              :content="e.publishedArr?e.publishedArr[ci]:'暂无'"
                              placement="top">
                    <!-- && e.websiteShowInfoList.length > 0 -->
                    <div class="changedesc">
                      <img src="@/assets/solicitationactivities/publishedIcon.png"
                           alt="">
                    </div>
                  </el-tooltip>
                </div>
                <!-- 修改图片信息 -->
                <!-- <el-tooltip class="item"
                            effect="dark"
                            content="修改图片说明"
                            placement="top">
                  <div v-if="e.isCheck === 1 && ce.atlasId === 0"
                       @click.stop="openChangeDesc(ce)"
                       class="changedesc">
                    <img src="@/assets/sreenpic/desc.png"
                         alt="">
                  </div>
                </el-tooltip> -->

                <!-- 查看图片 -->
                <!-- <el-tooltip class="item"
                            effect="dark"
                            content="查看图片"
                            placement="top">
                  <div @click.stop="seePic(ci,ce,e,i)"
                       class="seePic">
                    <img src="@/assets/solicitationactivities/see.png"
                         alt="">
                  </div>
                </el-tooltip> -->

                <!-- 选中图片 -->
                <img v-show="ce.isChoose"
                     class="choosepic"
                     src="@/assets/solicitationactivities/choose.png"
                     alt="">

                <!-- 已入库 -->
                <div v-if="ce.atlasId !== 0"
                     class="yrk">
                  已入库
                </div>
              </div>
            </div>

            <div @click="actRight(i)"
                 v-if="e.pictureCount > 7"
                 class="right">
              <img src="@/assets/picbrowse/rightjt.png"
                   width="20px"
                   alt />
            </div>
          </div>

          <div v-if="e.videosIds !== ''"
               class="tablebgbody">
            <div @click="seeVideo(e.videosIds)"
                 class="actimg actvideo">

            </div>
          </div>
        </div>

        <div v-if="listPictureActivity.length === 0 "
             style="display: flex;align-items: center;justify-content:center;height:600px;">
          <img src="@/assets/piclist/nonr.png"
               alt />
        </div>
      </div>

      <div class="pagination">
        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="currentPage"
                       :page-size="pageSize"
                       layout="prev, pager, next"
                       :total="total"></el-pagination>
      </div>
    </div>

    <!-- 详细内容 -->
    <!-- <el-dialog title="查看视频"
               :visible.sync="dialogVisiblevideo"
               width="45%"
               :before-close="handleClosevideo">
      <div style="width:100%;">
        <video :src="videoSrc" style="margin:20px auto;" controls="controls">您的浏览器不支持 video 标签。</video>
      </div>
    </el-dialog> -->

    <transition name="el-fade-in-linear">
      <div class="videobj"
           v-show="dialogVisiblevideo">
        <video controls="controls"
               id="playVideos"
               :src="videoSrc">
          您的浏览器不支持播放视频。
        </video>
        <div class="closeVideo"
             @click="handleClosevideo">关闭</div>
      </div>
    </transition>

    <changedescdialog :message="message"
                      :dialogVisible="descdialogVisible"
                      @handleClose="deschandleClose"
                      @changeDesc="changeDesc"></changedescdialog>

    <!-- 详细内容 -->
    <el-dialog :visible.sync="dialogVisibleInf"
               width="45%"
               :before-close="handleCloseInf">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>详细内容</div>
      </div>

      <div style="text-align:center;margin-bottom:20px;font-size:30px;font-weight:bold;">{{actInf.title}}</div>

      <div v-if="actInf.content"
           style="height:500px;overflow-y:auto;"
           v-html="actInf.content"></div>
      <div v-if="!actInf.content"
           style="height:500px;overflow-y:auto;">暂无内容</div>
    </el-dialog>

    <!-- 稿件入库 -->
    <el-dialog :visible.sync="dialogVisiblePutIn"
               width="26%"
               class="ruku"
               :before-close="handleClosePutIn">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>稿件入库</div>
      </div>
      <!-- <div class="curtain">
        <div @click="uploadMode = true" :class="{'active' : uploadMode}">创建新图集</div>
        <div @click="uploadMode = false" :class="{'active' : !uploadMode}">归档到图集</div>
      </div> -->
      <div v-if="uploadMode"
           class="nr">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="95px"
                 class="demo-ruleForm"
                 v-loading="dialogLoading">
          <el-form-item label="归属图库:"
                        prop="region">
            <el-cascader
                      style="width: 100%;"
                      v-model="ruleForm.region"
                      :options="libList"></el-cascader>
            <!-- <el-select v-model="ruleForm.region"
                       style="width:100%;"
                       placeholder="请选择图片库">
              <el-option v-for="item in libList"
                         :key="item.value + '-0'"
                         :label="item.label"
                         :value="item.value"
                         v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="图集名:"
                        prop="name">
            <el-input v-model="ruleForm.name"
                      placeholder="请输入图集名"></el-input>
          </el-form-item>
          <el-form-item label="可见性:"
                        prop="status">
            <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                            :disabled="statusFlag"
                            v-model="ruleForm.status"
                            size="small">
              <el-radio-button label="0">私密</el-radio-button>
              <el-radio-button label="1">公开</el-radio-button>
            </el-radio-group>
            <!-- <el-select
              style="width:100%;"
              v-model="ruleForm.status"
              placeholder="请选择"
            >
              <el-option
                v-for="item in visibilityList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
          </el-form-item>

          <el-form-item label="备注:"
                        prop="desc">
            <el-input type="textarea"
                      :autosize="{ minRows: 8, maxRows: 12}"
                      v-model="ruleForm.desc"
                      placeholder="选填，备注不超过200个字"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="!uploadMode"
           class="zhidingnr">
        <el-form label-width="95px"
                 v-loading="dialogLoading">
          <el-form-item label="指定图集:">
            <div @click.stop
                 class="inputlist">
              <el-input class="elinput"
                        style="width:100%;"
                        v-model="myselect"
                        placeholder="请输入关键字进行筛选"
                        @input="myLibChange">
              </el-input>
            </div>
          </el-form-item>

          <el-table ref="multipleTable"
                    :data="myAtlas"
                    stripe
                    height="400"
                    @row-click="rowClick"
                    highlight-current-row
                    style="width: 100%;overflow-y: auto;">
            <el-table-column prop="name"
                             show-overflow-tooltip
                             label="图集名">
            </el-table-column>
            <el-table-column prop="date"
                             label="创建时间">
            </el-table-column>

          </el-table>
        </el-form>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button :disabled="dialogLoading"
                   @click="handleClosePutIn">取 消</el-button>
        <el-button :disabled="dialogLoading"
                   type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="subPutIn">确 定</el-button>
        <el-button :disabled="dialogLoading"
                   type="primary"
                   v-if="isChoosePic"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="subPutDown">确定并下载</el-button>
      </span>
    </el-dialog>

    <!-- 用稿 -->
    <el-dialog :visible.sync="dialogVisibleMan"
               width="30%"
               class="clearMar"
               :before-close="handleCloseMan">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>用稿</div>
      </div>
      <div class="drawerbtn">
        <div>
          <div class="btnbj">
            <el-button v-if="powersObj.pictureDownload"
                       @click="downloadFlag = true"
                       class="btt">打包下载</el-button>
          </div>
          <!-- <br> -->
          <div class="btnbj">
            <el-button v-if="powersObj.pictureShare"
                       @click="chooseShare(0,'system-workgroup','工作圈',0)"
                       class="btt">分享至工作圈</el-button>
          </div>
          <!-- <br> -->
          <div class="btnbj">
            <el-button v-if="powersObj.picturePush"
                       @click="pushFlag = true"
                       class="btt">推送</el-button>
          </div>
        </div>

        <transition name="el-fade-in-linear">
          <div v-if="downloadFlag"
               class="download"
               @click="downloadFlag = false">
            <div @click.stop
                 style="width:400px;margin:45px auto;">
              <el-input placeholder="请输入打包标题"
                        v-model="downloadTitle">
                <el-button @click.stop="downloadPic"
                           slot="append">打包下载</el-button>
              </el-input>
            </div>
          </div>
        </transition>

        <transition name="el-fade-in-linear">
          <div v-if="shareFlag"
               class="share"
               @click="shareFlag = false">
            <div @click.stop
                 style="width:400px;margin:110px auto;">
              <el-input placeholder="请输入分享标题"
                        v-model="shareTitle">
                <el-button @click.stop="sharePic"
                           slot="append">分享</el-button>
              </el-input>
            </div>
          </div>
        </transition>

        <transition name="el-fade-in-linear">
          <div v-if="pushFlag"
               class="push"
               @click="pushFlag = false">
            <div style="width:430px;margin:30px auto 0;">
              <p>推送至</p>
              <div class="pushbj">
                <div @click.stop="choosePush(i,e.template,e.name,e.id)"
                     :class="pushIndex === i? isSimple ?  'pushlist simpleactive' : 'pushlist active':'pushlist'"
                     v-for="(e,i) in pushList"
                     :key="i">
                  {{e.name}}
                  <img v-if="pushIndex === i"
                       src="@/assets/house/checkInside.png"
                       alt />
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </el-dialog>

    <!-- 推送至图片邀约 -->
    <el-dialog width="26%"
               :before-close="handleClosePic"
               :visible.sync="mydialogVisible">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>推送至图片邀约</div>
      </div>
      <el-form :model="myform"
               ref="myform"
               label-width="70px"
               :rules="rulesyy">
        <!-- <el-form-item v-if="isSee" label="渠道名称：" prop="name">
            <el-input v-model="myform.name" placeholder="必填，2-10个字"></el-input>
        </el-form-item>-->
        <el-form-item label="标题："
                      prop="name">
          <el-select style="width:100%;"
                     v-model="myform.name"
                     @change="myformChange"
                     placeholder="请选择姓名">
            <el-option v-for="(e,i) in picInviteList"
                       :key="i"
                       :label="e.title"
                       :value="e"
                       v-html="'<span style=color:#303030;>'+e.title+'</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">备注：</div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="myform.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClosePic">取 消</el-button>
        <el-button type="primary"
                   v-if="!isClick"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitPic('myform')">提 交</el-button>
        <el-button type="primary"
                   v-else
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   disabled>提 交</el-button>
      </div>
    </el-dialog>

    <!-- 图片点击弹窗 -->
    <el-dialog :visible.sync="dialogVisiblePicInfo"
               class="picSee"
               width="90%"
               top="12vh"
               :show-close="false">
      <!-- 关闭按钮 -->
      <div @click="dialogVisiblePicInfo = false"
           class="close">
        <img :style="{'margin-top':displayResolution < 1600 ? '-2px':'0px'}"
             src="@/assets/picbrowse/close.png"
             alt />
      </div>

      <div class="left">
        <div class="pic"
             v-loading="imgLoading"
             element-loading-text="正在加载图片中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)">
          <div class="imgBj"
               ref="imgBj">
            <img ref="imgPic"
                 height="98%"
                 @contextmenu.prevent="rightShow($event)"
                 ondragstart="return false;"
                 @click="seeBigSmall"
                 v-lazy="choosePicMsg.src">
            <div @click="bigLeft"
                 class="leftjt">
              <div class="message"
                   v-show="showMessageLeft">这是第一张哟~</div>
            </div>
            <div @click="bigRight"
                 class="rightjt">
              <div class="message"
                   v-show="showMessageRight">这是最后一张哟~</div>
            </div>
            <i @click="picRotateRight"
               v-if="seeFull"
               class="el-icon-refresh-right"
               style="  position:absolute; bottom:20px; left:45%; font-size: 30px;"></i>
            <i @click="picRotateLeft"
               v-if="seeFull"
               class="el-icon-refresh-left"
               style="position:absolute; bottom:20px;font-size: 30px;"></i>
          </div>
          <!-- <img height="78%" :src="choosePicMsg.src"> -->

          <!-- <div class="picBtn">
            <i @click="picRotateRight"
               class="el-icon-refresh-right"></i>
            <i @click="picLarge"
               class="el-icon-zoom-in"></i>
            <i @click="picSmall"
               class="el-icon-zoom-out"></i>
            <i @click="picRotateLeft"
               class="el-icon-refresh-left"></i>
          </div> -->
        </div>

        <div class="picinf disflex">
          <!-- <p class="picinfleft">{{atlasInfo.name}} / 共<span>{{atlasInfo.pictureCount}}</span>张</p> -->
          <!-- <div class="picinfright disflex">
            <div v-if="powersObj.createAtlas" @click.stop="lovePic" class="disflex spare" :style="{background: !haslovechange ?'url('+ require('@/assets/picbrowse/spare.png') +') no-repeat':'url('+ require('@/assets/picbrowse/sparelove.png') +') no-repeat'}">
              <div class="icon"></div>
              
              <p>选用</p>
            </div>
            <div v-if="powersObj.createAtlas" @click="setIndexPic" class="disflex book">
              <div class="icon"></div>
              
              <p>设为封面</p>
            </div>
            <div v-if="powersObj.createAtlas" @click="deletePic" class="disflex delete">
              <div class="icon"></div>
              
              <p>删除</p>
            </div>
          </div>-->
        </div>

        <div ref="piclist"
             class="piclist">
          <div v-if="picAllListFlag >= 13 || scroll < -1"
               @click="smallLeft"
               class="leftjt">
            <i style="font-size:30px;"
               class="el-icon-arrow-left"></i>
          </div>

          <div ref="picalllist"
               style="display:flex;transition:1s;">
            <div @click="picListClick(e,i)"
                 v-for="(e,i) in picList"
                 :key="i">
              <!-- <img :src="e.src" :class="picAllListFlag === i || choosePicMsg.id === i ? 'picimg active':'picimg'" /> -->
              <div :style="{backgroundImage:'url(' + e.fileInfo.Wh160 + ')',cursor:'pointer'}"
                   @contextmenu.prevent="rightShow($event)"
                   ondragstart="return false;"
                   :class="picAllListFlag === i || choosePicMsg.myId === i ? 'picimg active':'picimg'"></div>
            </div>
          </div>

          <div v-if="picCha !== scroll && picList.length > 13"
               @click="smallRight"
               class="rightjt">
            <i style="font-size:30px;"
               class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <div class="right">
        <div class="title">
          <p>图片信息</p>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">拍摄时间</div>：
          <span>{{picExif.CreateAtMy || '无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">投稿时间</div>：
          <span>{{picInfo.createAt || '无'}}</span>
        </div>
        <div v-if="!picExif.CreateAtMy"
             style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">上传时间</div>：
          <span>{{picInfo.createAt || '无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">相机品牌</div>：
          <span>{{picExif.Make || '暂无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片尺寸</div>：
          <span>{{ picInfo.picW !== '暂无' ? picInfo.picW + '*' + picInfo.picH + '像素' :'暂无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片大小</div>：
          <span>{{picInfo.fileSize}}MB</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片格式</div>：
          <span>{{picInfo.format}}</span>
        </div>
        <div v-if="picExif.ExposureTime"
             style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">曝光时间</div>：
          <span>{{picExif.ExposureTime}}秒</span>
        </div>
        <div v-if="!picExif.ExposureTime"
             style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">曝光时间</div>：
          <span>暂无</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">ISO速度</div>：
          <span>{{picExif.ISOSpeedRatings || '暂无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片焦距</div>：
          <span>{{picExif.FocalLength || '暂无'}}</span>
        </div>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.desc">
          <p>图片说明</p>
        </div>

        <p style="line-height:26px;padding-left:8px;">{{choosePicMsg.desc}}</p>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.labels.length > 0 && !isSimple">
          <p>智能标签</p>
          <div class="alert">仅供参考</div>
        </div>

        <div v-if="!isSimple"
             style="display:flex;align-items: center;flex-wrap: wrap;width:100%;margin-top:10px;">
          <div style="margin-left:5px;margin-bottom:5px;"
               v-for="(e,i) in choosePicMsg.labels"
               :key="i">
            <el-tag>{{e}}</el-tag>
          </div>
        </div>

        <div class="msg disflex"
             v-if="false">
          <div class="picmsg">
            <p>{{choosePicMsg.shareCount}}</p>
            <div>浏览量</div>
            <img src="@/assets/picbrowse/see.png"
                 alt />
          </div>
          <div class="picmsg">
            <p>{{choosePicMsg.pushCount}}</p>
            <div>推送量</div>
            <img src="@/assets/picbrowse/msgpush.png"
                 alt />
          </div>
          <div class="picmsg">
            <p>{{choosePicMsg.downloadCount}}</p>
            <div>平台数</div>
            <img src="@/assets/picbrowse/platform.png"
                 alt />
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 查看所选中的图片 -->
    <el-dialog :visible.sync="dialogVisibleChosePic"
               width="60%"
               :before-close="handleCloseChosePic">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>选中图片</div>
      </div>
      <div class="csepic">
        <div class="pic"
             v-for="(e,i) in choosePicList"
             :key="i"
             :style="{backgroundImage:'url(' + e.fileInfo.scr +')'}">
          <div class="delete">
            <img @click="onlyOneDel(i)"
                 src="@/assets/container/delete.png"
                 alt="">
          </div>
        </div>

        <div @click="oneDownload"
             class="downloadin"
             :style="isSimple?'background-color:#fd9112;':''">
          <img src="@/assets/piclist/downloadout.png"
               alt="">
          <p>一键下载</p>
        </div>

        <div @click="oneDel"
             class="cleanup"
             :style="isSimple?'background-color:#fd9112;':''">
          <img src="@/assets/container/cleanup.png"
               alt="">
          <p>一键清除</p>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="26%"
               :before-close="handleCloseWork"
               :visible.sync="dialogVisibleWork">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>分享至工作圈</div>
      </div>
      <el-form :model="workForm"
               ref="workForm"
               label-width="110px"
               :rules="workRules">
        <el-form-item label="标题："
                      prop="name">
          <el-input v-model="workForm.name"
                    placeholder="必填，2-10个字"></el-input>
        </el-form-item>
        <el-form-item label="选择工作圈："
                      prop="work">
          <!-- multiple -->
          <el-select :remote-method="selectWork"
                     remote
                     v-model="workForm.work"
                     filterable
                     style="width:100%;"
                     placeholder="请选择工作圈">
            <el-option style="width:100%;"
                       v-for="item in workList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"
                       v-html="'<span style=color:#303030;>'+item.name+'</span>'">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">
            备注：
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="workForm.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleCloseWork">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitWork('workForm')">提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog width="26%"
               :before-close="handleCloseUser"
               :visible.sync="dialogVisibleUser">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>推送至用户</div>
      </div>
      <el-form :model="userForm"
               ref="userForm"
               label-width="100px"
               :rules="userRules">
        <el-form-item label="标题："
                      prop="name">
          <el-input v-model="userForm.name"
                    placeholder="必填，2-10个字"></el-input>
        </el-form-item>
        <el-form-item label="选择用户："
                      prop="user">
          <!-- multiple -->
          <el-select :remote-method="selectUser"
                     remote
                     v-model="userForm.user"
                     filterable
                     style="width:100%;"
                     placeholder="请选择用户">
            <el-option style="width:100%;"
                       v-for="item in userList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"
                       v-html="'<span style=color:#303030;>'+item.name+'</span>'">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">
            备注：
          </div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="userForm.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleCloseUser">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitUser('userForm')">提 交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  articlePicturesNumbers
} from '@/api/pictureActivityArticle'

import { mypicinvitetable } from "@/components/index";
import { getPicture, addPicture, getPictures, updatePicture } from "@/api/picture";
import { getVideo } from "@/api/video";
import { listWorkgroup } from "@/api/workgroup";
import { getUser, getUserAuthInfo } from "@/api/user";
import { getFileInfoById } from "@/api/file";
import { listAllowPushChannel } from "@/api/pushChannel";
import { myPictureNeed } from "@/api/pictureNeed";
import {
  listPictureActivityArticle,
  listPictureActivityArticles,
  deletePictureActivityArticle,
  articleWorkflow,
  setCheck,
  setStatus,
  batchUpdatePictureActivityArticle
} from "@/api/pictureActivityArticle";
import { picPrefix } from "@/constants/piccommon";
import { allowLib, powersObj } from "@/constants/powers";
import { listLib } from "@/api/lib";
import { addAtlas } from "@/api/atlas";
import { addPicturePackage } from "@/api/picturePackage";
import { getDate, formatConversion } from "@/plugins/getdate";
import { listPictureActivity } from "@/api/pictureActivity";
import { searchAtlas } from "@/api/search";
import { getUserSetting, setUserSetting } from '@/api/config'
import { changedescdialog } from '@/components/index'
import { fullScreen, exitFullscreen, checkFull } from "@/plugins/fullScreen";
import { listWebsiteColumn } from "@/api/open";


import { listUser } from "@/api/user";


export default {
  components: { changedescdialog },
  computed: {
    ...mapGetters(["createUid"])
  },
  data () {
    return {

      //可见性权限
      statusFlag: false,

      seeFull: false,
      //权限
      allowLib,
      powersObj,

      totals: 0,

      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      timeInt: "",
      activity: "",
      status: -1,
      isCheck: -1,
      choosePicList: [],
      //是否是选择的图片入库
      isChoosePic: false,
      isCheckList: [
        {
          value: -1,
          label: "不限"
        },
        {
          value: 0,
          label: "待审核"
        },
        {
          value: 1,
          label: "已通过"
        },
        {
          value: 2,
          label: "不通过"
        }
      ],
      statusList: [
        {
          value: -1,
          label: "不限"
        },
        {
          value: 0,
          label: "未入库"
        },
        {
          value: 1,
          label: "已入库"
        },
        {
          value: 2,
          label: "已用稿"
        }
      ],
      activityList: [],
      warehousingTime: "",
      listPictureActivity: [],

      libList: [],

      picPrefix,
      dialogVisibleInf: false,
      dialogVisiblePutIn: false,
      dialogVisibleMan: false,
      dialogVisiblePicInfo: false,
      actInf: "",

      putinPicIds: [],
      atlasId: "",
      libId: "",
      uploadMode: true,

      //指定图集
      myAtlas: [],
      myselect: '',

      visibilityList: [
        {
          value: "1",
          label: "公开"
        },
        {
          value: "0",
          label: "私密"
        }
      ],

      ruleForm: {
        name: "",
        region: "",
        desc: "",
        status: "0"
      },
      rules: {
        name: [
          { required: true, message: "请输入图集名", trigger: "blur" },
          { min: 1, max: 60, message: "长度在 1 到 60 个字符", trigger: "blur" }
        ],
        region: [
          { required: true, message: "请选择图片库", trigger: "change" }
        ],
        status: [{ required: true, message: "请选择可见性", trigger: "change" }],
        desc: [
          {
            min: 0,
            max: 200,
            message: "长度不得超过200个字符",
            trigger: "blur"
          }
        ]
      },

      downloadFlag: false,
      shareFlag: false,
      pushFlag: false,
      downloadTitle: "",
      shareTitle: "",
      pushTitle: "",
      pushList: [],
      template: "",
      pushIndex: 0,
      pushChannelId: "",
      mydialogVisible: false,

      pictureArray: [],
      pictureString: [],
      picInviteList: [],
      myform: {
        name: "",
        note: "",
        createUid: this.createUid,
        id: ""
      },
      rulesyy: {
        name: [{ required: true, message: "请选择模板", trigger: "change" }]
      },



      //图片浏览
      clickFlag: 0,
      displayResolution: "",
      choosePicMsg: { labels: [] },
      picList: [],
      imgLoading: false, //图片加载
      atlasInfo: {},
      picInfo: {},
      picExif: {},
      picCha: "",
      picAllListFlag: -1,

      scroll: 0,
      isRefresh: false,
      dialogLoading: false,

      picTimes: 1,
      picDeg: 0,

      //图片说明
      descdialogVisible: false,
      message: '',

      //选中的图片
      dialogVisibleChosePic: false,


      //查看用户基本信息
      userInfo: {
        name: '',
        realName: '',
        mobile: '',
        email: ''
      },


      //双击问题处理
      isClick: false,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,



      //视频相关
      videoSrc: '',
      dialogVisiblevideo: false,

      //分享到工作圈
      dialogVisibleWork: false,
      workForm: {
        name: "",
        work: "",
        createUid: this.createUid,
        note: ""
      },
      workRules: {
        name: [{ required: true, message: "请输入标题", trigger: "change" }],
        work: [{ required: true, message: "请选择工作圈", trigger: "change" }],
      },
      workList: [],

      //推送到用户
      dialogVisibleUser: false,

      userForm: {
        name: "",
        user: "",
        createUid: this.createUid,
        note: ""
      },
      userRules: {
        name: [{ required: true, message: "请输入标题", trigger: "change" }],
        user: [{ required: true, message: "请选择用户", trigger: "change" }],
      },
      userList: [],
      showMessageLeft: false,
      showMessageRight: false,
      useActivityArr: [],

      columnNameArr: [],
      activityArticleInfo: '',
      isCheckAuthor: -1,
      isCheckStatus: -1,


      thumb:'original',


      //选中稿件
      selectActList:[]
    };
  },
  methods: {
    selectAct(e,i){
      
      if(this.selectActList.length > 0){
        let flag = false
        let index = -1
        for (let i = 0; i < this.selectActList.length; i++) {
          if(this.selectActList[i].id == e.id){
            flag = true
            index = i
            break;
          }
        }

        if(flag){
          this.listPictureActivity[i].isSelect = false
          this.selectActList.splice(index,1)
        }else{
          this.listPictureActivity[i].isSelect = true
          this.selectActList.push(e)
        }
      }else{
        this.listPictureActivity[i].isSelect = true
        this.selectActList.push(e)
      }
      
      this.$forceUpdate()
    },
    batchRelease(){
      if(this.selectActList.length <= 0){
        this.$message.warning({ message:'请选择稿件！'});
        return false;
      }
      this.$confirm('确认发布吗？', {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          for (let i = 0; i < this.selectActList.length; i++) {
            this.selectActList[i].isPost = 1
          }
          this.batchUpdatePictureActivityArticleAsync(this.selectActList)
        })
        .catch(e => {

        });
    },
    
    //设置审核结果
    async batchUpdatePictureActivityArticleAsync (val) {
      let { status, data, message, errors } = await batchUpdatePictureActivityArticle(val);
      if (status) {
        this.$message.success("发布成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    articlePicturesNumbersapi () {
      let params = {}
      params.pictureActivityId = 0
      params.websiteColumnId = this.activity == '不限' ? 0 : this.activity || 0,
        params.isCheck = this.isCheck
      params.status = -1
      params.authStatus = this.isCheckAuthor
      params.isPost = this.isCheckStatus
      params.articleType = 'column'
      console.log(params);
      articlePicturesNumbers(params).then(res => {
        this.totals = res.data
      })
    },
    publishing (item) {
      sessionStorage.setItem("actPic", JSON.stringify(item.pictureInfo));
      console.log(item.pictureInfo);
      // return
      if (item.isCheck === 1) {

      } else {
        let id = item.id
        this.setCheckAsync({ id, isCheck: 1, message: '' });
      }
      localStorage.setItem('activityArticleInfo', JSON.stringify(item))
      // sessionStorage.setItem("actPic", JSON.stringify(item.pictureInfo));
      this.activityArticleInfo = item
      // this.useGao(item)
      this.listAllowPushChannelAsync()
      setTimeout(() => {
        this.choosePush(2, this.pushList[2].template, this.pushList[2].name, this.pushList[2].id)
      }, 1000);
    },
    async getReasonAsync (item) {
      console.log(item);
      let { status, data, message } = await articleWorkflow({ pictureActivityArticleId: item.id })
      if (status) {
        this.$alert(data.message, '拒绝理由', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
    },
    myformChange (val) {
      console.log(val);
      this.myform.name = val.title;
      this.myform.id = val.id;
    },
    async listWebsiteColumnAsync () {
      let val = { parentId: 0 }
      let { status, data } = await listWebsiteColumn(val)
      if (status) {
        for (let i = 0; i < data.length; i++) {
          this.listWebsiteColumnSonAsync(data[i].id)
        }
      }
      setTimeout(() => {
        this.searchClick()
      }, 1000);
    },
    async listWebsiteColumnSonAsync (value) {
      let val = {
        parentId: value
      }
      let { status, data } = await listWebsiteColumn(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          this.columnNameArr.push(data[i])
        }
        console.log(this.columnNameArr);
        // this.activity = this.columnNameArr[0].id
      }
    },

    //推送到个人
    handleCloseUser () {
      this.dialogVisibleUser = false;
    },

    //用户名筛选
    selectUser (query) {
      let dataExa
      if (query !== '') {
        dataExa = { userType: 0, keyword: query }
        this.listUserAsync(dataExa)
      } else {
        dataExa = { userType: 0 }
        this.listUserAsync(dataExa)
      }
    },
    submitUser (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.comPic('push', this.userForm)
          this.dialogVisibleUser = false
          this.dialogVisibleMan = false
          this.$router.push('/shareAndPush/myPush')
          this.$nextTick(() => {
            this.pushFlag = false
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //获取用户列表
    async listUserAsync (val) {
      let { status, data, message, errors } = await listUser(val);
      if (status) {
        this.userList = data;

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //分享选择
    chooseShare (i, t, name, id) {
      console.log(1);
      this.shareIndex = i
      this.template = t
      this.pushChannelId = id
      this.sharePic()
    },
    handleCloseWork () {
      this.$refs['workForm'].resetFields();

      this.dialogVisibleWork = false
    },

    //分享
    sharePic () {
      console.log(this.template);
      if (this.template === 'system-workgroup') {
        this.dialogVisibleWork = true
        this.listWorkgroupAsync()
      }

    },

    //分享到工作圈
    submitWork (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          let choosePicMsg = {
            createUid: this.createUid,
            packageType: 'share',
            pictureCount: this.pictureArray.length,
            pictureIds: this.pictureString,
            targetUid: 0,
            targetWorkgroupId: this.workForm.work,
            title: this.workForm.name,
            shareConfig: JSON.stringify({ pushChannelId: this.pushChannelId, note: this.workForm.note })
          }

          this.addPicturePackageAsync(choosePicMsg)
          this.dialogVisibleMan = false
          this.dialogVisibleWork = false
          setTimeout(() => {
            this.$router.push('/shareAndPush/myShare')
          }, 1500);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //工作圈筛选
    selectWork (query) {
      let dataExa
      if (query !== '') {
        dataExa = { page: 0, pageSize: 20, keyword: query }
        this.listWorkgroupAsync(dataExa)
      } else {
        dataExa = { page: 0, pageSize: 20 }
        this.listWorkgroupAsync(dataExa)
      }
    },

    //获取工作圈列表
    async listWorkgroupAsync (val) {
      let { status, data, message, errors } = await listWorkgroup(val);
      if (status) {
        this.workList = data;

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


    handleClosevideo () {
      this.dialogVisiblevideo = false
      this.videoSrc = ''
    },

    //打开视频
    seeVideo (id) {
      this.getVideoAsync(id)
    },

    //获取用户信息
    async getVideoAsync (val) {
      let { status, data, message } = await getVideo(val);
      if (status) {
        this.videoSrc = picPrefix + data.fileInfo.savepath
        console.log(this.videoSrc);
        this.dialogVisiblevideo = true
      } else {
        this.$message.warning('获取视频失败')
      }
    },

    //图片右击
    rightShow (e) {
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },


    seeInfoClick (id) {
      this.getUserAsync(id)
    },
    //获取用户信息
    async getUserAsync (val) {
      let { status, data, message } = await getUser(val);
      if (status) {
        this.userInfo.realName = ''
        this.userInfo.name = data.name
        this.userInfo.mobile = data.mobile
        this.userInfo.email = data.email

        if (data.authStatus == 1) {
          this.getUserAuthInfoAsync(val)
        }
      } else {
        this.$message.warning('获取用户信息失败')
      }
    },

    //获取用户认证信息
    async getUserAuthInfoAsync (val) {
      let { status, data, message } = await getUserAuthInfo(val);
      if (status) {
        this.userInfo.realName = data.realName
        // this.dialogVisible = true
      } else {
        this.$message.warning('获取用户信息失败')
      }
    },



    seeBigSmall () {
      this.seeFull = !this.seeFull
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      this.picTimes = 1
      this.picDeg = 0
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      if (this.seeFull) {
        fullScreen(this.$refs.imgBj)
        this.$refs.imgPic.style.cursor = 'zoom-out'
      } else {
        exitFullscreen()
        this.$refs.imgPic.style.cursor = 'zoom-in'
      }
    },
    //选择图片事件
    handleCloseChosePic () {
      this.dialogVisibleChosePic = false
    },
    //一键清除
    oneDel () {
      this.$confirm('确认全部删除吗？', {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.choosePicList = []
          this.setUserSettingAsync(this.createUid, 'choosePicList', { value: null })
          this.$message.success('全部删除成功')
          this.dialogVisibleChosePic = false
        })
        .catch(e => {
          // console.log('取消')
        });
    },
    //一键下载
    oneDownload () {
      

      let idArr = []
      let parameter = []
      for (let i = 0; i < this.choosePicList.length; i++) {

        idArr.push(this.choosePicList[i].id)
        parameter.push({
          pictureActivityId: this.choosePicList[i].actInfo.pictureActivityId,
          pictureActivityArticleId: this.choosePicList[i].actInfo.id,
          websiteColumnId: this.choosePicList[i].actInfo.websiteColumnId,
          title: this.choosePicList[i].actInfo.title,
          createUserInfo: this.choosePicList[i].actInfo.createUserInfo,
          pictureId:this.choosePicList[i].id
        })
      }
      this.$confirm('请选择下载清晰度!', {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除,
        distinguishCancelAndClose: true,
        confirmButtonText: '原图',
        cancelButtonText: '低'
      })
        .then(e => {
          let choosePicMsg = {
            createUid: this.createUid,
            packageType: 'download',
            pictureCount: this.choosePicList.length,
            pictureIds: idArr.join(','),
            title: '我的下载',
            downloadConfig: JSON.stringify({ 
              thumb:'original',
              mix:1,
              parameter
            }) || ''
          }
          this.addPicturePackageAsync(choosePicMsg)
        })
        .catch(action => {
          if(action == 'cancel'){
            let choosePicMsg = {
              createUid: this.createUid,
              packageType: 'download',
              pictureCount: this.choosePicList.length,
              pictureIds: idArr.join(','),
              title: '我的下载',
              downloadConfig: JSON.stringify({ thumb:'small',mix:1,parameter }) || ''
            }
            this.addPicturePackageAsync(choosePicMsg)
          }
        });
    },
    //清除
    onlyOneDel (i) {
      this.$confirm('确认删除吗？', {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.choosePicList.splice(i, 1)
          let idsInfo = []
          for (let k = 0; k < this.choosePicList.length; k++) {
            idsInfo.push({
              id: this.choosePicList[k].id,
            })
          }
          this.setUserSettingAsync(this.createUid, 'choosePicList', { value: idsInfo })
          this.$message.success('删除成功')
        })
        .catch(e => {
          // console.log('取消')
        });
    },

    //添加到图集
    async updatePictureAddAsync (val) {
      let { status, data, message } = await updatePicture(val);
      if (status) {
        // this.$message.success("修改成功！")
      }
    },

    //修改图片说明
    changeDesc (val) {
      this.updatePictureAsync(val)
      this.descdialogVisible = false
    },
    deschandleClose () {
      this.descdialogVisible = false
    },
    openChangeDesc (val) {
      // console.log(val)
      this.message = val
      this.descdialogVisible = true
    },
    //修改图片说明
    async updatePictureAsync (val) {
      let { status, data, message, errors } = await updatePicture(val);
      if (status) {
        this.$message.success("修改成功！")
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //换行事件
    turn (data) {
      return data.replace(/\n\n/g, "<br/>");
    },
    turn1 (data) {
      return data.replace(/\n/g, "<br/>");
    },
    //指定图集事件
    myLibChange () {
      // console.log(this.myselect)
      if (!this.myselect) {
        this.myAtlas = []
        this.searchAtlasAsync({ pageSize: 20, page: 0, createUid: this.createUid })
      }
      if (this.myselect.length >= 2) {
        this.myAtlas = []
        this.searchAtlasAsync({ keyword: this.myselect, pageSize: 50, page: 0, createUid: this.createUid })
      }
      // this.myLibId = i.libId
      // this.myAtlasId = i.id
    },

    rowClick (row) {
      this.libId = row.libId
      this.atlasId = row.atlasId
    },


    comPic (val, tt) {
      // console.log(val,tt)
      let choosePicMsg = {
        createUid: this.createUid,
        packageType: val,
        pictureCount: this.pictureArray.length,
        pictureIds: this.pictureString,
        targetUid: tt.user || 0,
        title: tt.name || tt.title || tt,
        pushConfig:
          JSON.stringify({
            pushChannelId: this.pushChannelId,
            pictureNeedId: tt.id,
            note: tt.note
          }) || "",
        downloadConfig: JSON.stringify({ 
          thumb:this.thumb,
          pictureActivityId: this.activity == '不限' ? 0 : this.activity || 0,
          pictureActivityArticleId: this.activityArticleInfo.id,
          websiteColumnId: this.activityArticleInfo.websiteColumnId,
          title: this.activityArticleInfo.title,
          createUserInfo: this.activityArticleInfo.createUserInfo,
         }) || ''
      };

      this.addPicturePackageAsync(choosePicMsg);
    },
    //图片放大
    picLarge () {
      this.picTimes += 1.5
      if (this.picTimes < 6) {
        this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      } else {
        this.picTimes = 6
        this.$refs.imgPic.style.transform = 'scale(6) rotateZ(' + this.picDeg + 'deg)';
      }
    },
    //图片缩小
    picSmall () {
      this.picTimes -= 1.5
      if (this.picTimes > 1) {
        this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      } else {
        this.picTimes = 1
        this.$refs.imgPic.style.transform = 'scale(1) rotateZ(' + this.picDeg + 'deg)';
      }
    },

    //图片旋转
    picRotateLeft () {
      this.picDeg -= 90
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)'
    },
    //图片旋转
    picRotateRight () {
      this.picDeg += 90
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)'
    },
    //清除放大缩小效果
    clearLargeAndSmall () {
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      this.picTimes = 1
      this.picDeg = 0
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
    },

    //滚动加载图片
    scrollPic () {
      let isBottom =
        document.documentElement.scrollTop + window.innerHeight ===
        document.body.offsetHeight;
      if (isBottom) {
        if (this.listPictureActivity.length !== this.total) {
          // this.currentPage++;
          this.handleCurrentChange(this.currentPage + 1)
          // let params = {
          //   page: this.currentPage - 1,
          //   pageSize: this.pageSize,
          //   isCheck: this.isCheck || -1,
          //   status: this.status || -1,
          //   pictureActivityId: this.activity || 0
          // };
          // this.listPictureActivityArticleAsync(params);
        }
      }
    },

    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      // let data
      // if (this.isCheck == 0) {
      //   data = {
      //     page: this.currentPage - 1,
      //     pageSize: this.pageSize,
      //     isCheck: this.isCheck,
      //     status: -1,
      //     pictureActivityId: this.activity || 0
      //   };
      // } else if (this.isCheck == 1) {
      //   data = {
      //     page: this.currentPage - 1,
      //     pageSize: this.pageSize,
      //     isCheck: this.isCheck || -1,
      //     status: -1,
      //     pictureActivityId: this.activity || 0
      //   };
      // } else if (this.isCheck == 2) {
      //   data = {
      //     page: this.currentPage - 1,
      //     pageSize: this.pageSize,
      //     isCheck: this.isCheck || -1,
      //     status: -1,
      //     pictureActivityId: this.activity || 0
      //   };
      // } else if (this.isCheck == -1) {
      let data = {
        page: this.currentPage - 1,
        pageSize: this.pageSize,
        isCheck: this.isCheck,
        websiteColumnId: this.activity == '不限' ? 0 : this.activity || 0,
        pictureActivityId: 0,
        isPost: this.isCheckStatus,
        articleType: 'column'
      };
      // }
      // console.log(data)

      this.listPictureActivityArticleAsync(data);

      setTimeout(() => {
        window, scrollTo(0, 0)
      }, 1000);
    },
    clearInput () {
      this.activity = '不限'
    },
    //刷新表格
    refresh () {
      this.status = -1;
      this.isCheck = -1;
      if (powersObj.manageAllPictureActivity) {
        this.listPictureActivityAsync({ createUid: -1, pageSize: 100 });
      } else if (powersObj.myPictureActivity) {
        this.listPictureActivityAsync({ createUid: 0, pageSize: 100 });
      } else {
        this.$message.warning('获取活动列表失败！')
      }
    },

    //判断选中的图片在什么位置
    beSurePic (i, num) {
      if (i > num) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        this.scroll = i * -80;
        // console.log(piclistwidth - picalllistwidth)
        // console.log(this.scroll)
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 70;
          this.picCha = this.scroll;
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + ")";
        this.scroll = 0;
      }
    },

    //获取图片信息
    getPicInfo (e) {
      // console.log(e)
      this.picInfo.picH = e.fileInfo.picH || "暂无";
      this.picInfo.picW = e.fileInfo.picW || "暂无";
      this.picInfo.format =
        e.fileInfo.savepath.substring(e.fileInfo.savepath.length - 3) || "jpg";
      this.picInfo.createAt = formatConversion(
        e.fileInfo.createAt.toString()
      ).substring(0, 10);
      if (e.createAt !== 0) {
        this.picInfo.toConCreateAt = formatConversion(
          e.createAt.toString()
        ).substring(0, 10);
      } else {
        this.picInfo.toConCreateAt = ''
      }

      this.picInfo.fileSize =
        (e.fileInfo.fileSize / 1024 / 1024).toFixed(2) || "暂无";

      if (!e.exif) {
        this.picExif = {};
      } else {
        this.picExif = e.exif;
        if (e.exif.CreateAt) {
          if (this.picExif.CreateAt) {
            this.picExif.CreateAtMy = formatConversion(this.picExif.CreateAt.toString()).substring(0, 10)
          } else {
            this.picExif.CreateAtMy = formatConversion(e.exif.CreateAt.toString()).substring(0, 10)
          }
        } else {
          this.picExif.CreateAtMy = null;
        }
      }
    },

    //图片浏览
    seePic (i, e, picList) {
      this.dialogVisiblePicInfo = true;
      this.choosePicMsg = {};
      // console.log(e)
      // e.labels=['风景','运动员','环境','劳作','亲子活动','开会','抗洪抢险','剪裁']
      this.choosePicMsg.id = e.id;
      this.choosePicMsg.labels = e.labels
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.src = e.fileInfo.srcW1080;
      this.choosePicMsg.myId = i;
      this.picAllListFlag = i;
      this.picList = picList.pictureInfo;

      this.getPicInfo(e);

      this.$nextTick(() => {
        this.clearLargeAndSmall()
        this.beSurePic(i, 10);
      });
    },

    //选择图片
    openDialog (i, e, be, bi) {
      if (this.listPictureActivity[bi].pictureInfo[i].isChoose) {
        this.listPictureActivity[bi].pictureInfo[i].isChoose = false
        for (let i = 0; i < this.choosePicList.length; i++) {
          if (this.choosePicList[i].id == e.id) {
            this.choosePicList.splice(i, 1)
          }

        }
        let idsInfo = []
        for (let k = 0; k < this.choosePicList.length; k++) {
          idsInfo.push({
            id: this.choosePicList[k].id,
          })
        }
        this.setUserSettingAsync(this.createUid, 'choosePicList', { value: idsInfo })
      } else {
        this.listPictureActivity[bi].pictureInfo[i].isChoose = true
        this.choosePicList.push({
          ...e,
          actInfo:{
            ...be
          }
        })
        let idsInfo = []
        for (let k = 0; k < this.choosePicList.length; k++) {
          idsInfo.push({
            id: this.choosePicList[k].id,
          })
        }
        // console.log(this.choosePicList)
        this.setUserSettingAsync(this.createUid, 'choosePicList', { value: idsInfo })
      }
      this.choosePicMsg = {};
      // console.log(e)
      this.choosePicMsg.id = e.id;
      this.choosePicMsg.labels = e.labels
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.src = e.fileInfo.srcW1080;
      this.choosePicMsg.srcW1080 = e.fileInfo.srcW1080;
      this.choosePicMsg.myId = i;
      this.picAllListFlag = i;
      this.picList = be.pictureInfo;

      this.getPicInfo(e);


      // console.log(this.listPictureActivity[bi].pictureInfo[i].isChoose)
    },

    //图片浏览中大的箭头 左边
    bigLeft () {
      if (this.choosePicMsg.myId === 0) {
        if (!this.showMessageLeft) {
          this.showMessageLeft = true
          setTimeout(() => {
            this.showMessageLeft = false
          }, 1500);
        }
        return;
      }
      this.clearLargeAndSmall()
      this.choosePicMsg.labels = this.picList[this.choosePicMsg.myId - 1].labels
      this.choosePicMsg.src = this.picList[this.choosePicMsg.myId - 1].fileInfo.srcW1080;
      this.choosePicMsg.srcW1080 = this.picList[this.choosePicMsg.myId - 1].fileInfo.srcW1080;
      this.choosePicMsg.desc = this.picList[this.choosePicMsg.myId - 1].desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.id = this.picList[this.choosePicMsg.myId - 1].id;

      this.getPicInfo(this.picList[this.choosePicMsg.myId - 1]);

      this.choosePicMsg.myId = this.choosePicMsg.myId - 1;
      // console.log(this.choosePicMsg)
      this.picAllListFlag = this.choosePicMsg.myId;
      if (this.choosePicMsg.myId < 10) {
        this.scroll = 0;
        this.picCha = -1;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.scroll = this.scroll + 3 * this.choosePicMsg.myId;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },
    //图片浏览中大的箭头 右边
    bigRight () {
      if (this.choosePicMsg.myId === this.picList.length - 1) {
        if (!this.showMessageRight) {
          this.showMessageRight = true
          setTimeout(() => {
            this.showMessageRight = false
          }, 1500);
        }
        return;
      }
      this.clearLargeAndSmall()
      this.choosePicMsg.labels = this.picList[this.choosePicMsg.myId + 1].labels
      // this.picListClick(this.picList[this.choosePicMsg.id + 1],this.choosePicMsg.id + 1)
      this.choosePicMsg.src = this.picList[this.choosePicMsg.myId + 1].fileInfo.srcW1080;
      this.choosePicMsg.srcW1080 = this.picList[this.choosePicMsg.myId + 1].fileInfo.srcW1080;
      this.choosePicMsg.desc =
        this.picList[this.choosePicMsg.myId + 1].desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.id = this.picList[this.choosePicMsg.myId + 1].id;

      this.getPicInfo(this.picList[this.choosePicMsg.myId + 1]);

      this.choosePicMsg.myId = this.choosePicMsg.myId + 1;
      this.picAllListFlag = this.choosePicMsg.myId;
      // console.log(this.choosePicMsg)
      if (this.choosePicMsg.myId > 10) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        // console.log(this.scroll)
        // console.log(this.choosePicMsg.myId)
        if (this.scroll === 0) {
          this.scroll = this.choosePicMsg.myId * -70;
        } else {
          if (this.choosePicMsg.myId > 50) {
            this.scroll = this.scroll - 2 * this.choosePicMsg.myId;
          } else {
            this.scroll = this.scroll - 3 * this.choosePicMsg.myId;
          }
        }
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 80;
          setTimeout(() => {
            this.picCha = this.scroll;
          }, 1000);
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },
    //图片浏览小的箭头 右边
    smallRight () {
      let picalllistwidth = this.$refs.picalllist.offsetWidth;
      let piclistwidth = this.$refs.piclist.offsetWidth;
      this.scroll = this.scroll - 300;
      if (this.scroll < piclistwidth - picalllistwidth) {
        this.scroll = piclistwidth - picalllistwidth - 70;
        this.picCha = this.scroll;
        // console.log(this.scroll)
      }

      this.$refs.picalllist.style.transform =
        "translateX(" + this.scroll + "px)";
    },
    //图片浏览小的箭头 左边
    smallLeft () {
      this.scroll = this.scroll + 300;
      if (this.scroll > 0) {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + "px)";
        this.scroll = 0;
      } else {
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },

    //图片浏览中图片点击
    picListClick (e, i) {
      this.clearLargeAndSmall()
      this.choosePicMsg.id = e.id;
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.src = e.fileInfo.srcW1080;
      this.choosePicMsg.srcW1080 = e.fileInfo.srcW1080;
      this.choosePicMsg.myId = i;
      this.picAllListFlag = i;

      this.getPicInfo(e);
    },

    //搜索
    searchClick () {
      this.listPictureActivity = []
      this.currentPage = 1
      let data = {
        page: 0,
        pageSize: this.pageSize,
        isCheck: this.isCheck,
        // status: this.status,
        websiteColumnId: this.activity == '不限' ? 0 : this.activity || 0,
        pictureActivityId: 0,
        authStatus: this.isCheckAuthor,
        isPost: this.isCheckStatus,
        articleType: 'column'
      };

      this.listPictureActivityArticleAsync(data);
    },

    //用稿操作
    useGao (e) {
      console.log(e);
      this.activityArticleInfo = e
      localStorage.setItem('activityArticleInfo', JSON.stringify(e))
      // this.useActivityArr = e.pictureInfo
      // localStorage.setItem('useActivityArr', e.pictureInfo)
      this.putinPicIds = e
      this.pictureArray = e.pictureIdsArray;
      this.pictureString = e.pictureIds;
      sessionStorage.setItem("actPic", JSON.stringify(e.pictureInfo));
      this.listAllowPushChannelAsync();
      this.dialogVisibleMan = true;
    },
    //图片包操作
    //推送
    pushPic (name) {
      // return
      if (this.template === "picture-website") {
        this.handleClose()
        this.dialogVisibleMan = false
        this.$router.push({
          path: '/shareAndPush/push/show',
          query: {
            isSavePic: this.isSavePic,
            name: name,
            isDrawer: !this.switchFlag ? false : true,
            isSwitch: this.switchFlag,
            pushChannelId: this.pushChannelId,
            isColumn: true,
            activityArticleId: this.activityArticleInfo.id,
            // actName: this.activityArticleInfo.penName ? this.activityArticleInfo.penName : this.activityArticleInfo.actUser
          }
        })
      } else
        if (this.template === "routersoft-qms") {
          this.handleClose();
          this.dialogVisibleMan = false
          this.$router.push({
            path: "/shareAndPush/push/qms",
            query: {
              isSavePic: this.isSavePic,
              name: name,
              isAct: true,
              pushChannelId: this.pushChannelId
            }
          });
        } else if (
          this.template === "routersoft-rmt" ||
          this.template === "routersoft-mcp"
        ) {
          this.handleClose();
          this.dialogVisibleMan = false
          this.$router.push({
            path: "/shareAndPush/push/mcp",
            query: {
              isSavePic: this.isSavePic,
              name: name,
              isAct: true,
              pushChannelId: this.pushChannelId
            }
          });
        } else if (
          this.template === "picture-need" ||
          this.template === "system-picture-need"
        ) {
          this.listPictureNeedAsync();
          this.mydialogVisible = true;
        } else if (this.template === 'picture-user') {
          this.dialogVisibleUser = true
          this.listUserAsync({ userType: 0 })
        }
    },
    handleClosePic () {
      this.mydialogVisible = false;
      // this.clearData()
    },
    //推送选择
    choosePush (i, t, name, id) {
      this.pushIndex = i;
      this.template = t;
      this.pushChannelId = id;
      this.pushPic(name);
    },
    //图片tuo
    submitPic (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.isClick = true
          setTimeout(() => {
            this.isClick = false
          }, 2000);
          this.comPic("push", this.myform);
          this.mydialogVisible = false;
          let params = {
            id: this.putinPicIds.id,
            status: 2
          }
          this.pushSetStatus(params)
          this.$router.push("/shareAndPush/myPush");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose () {
      this.downloadFlag = false;
      this.shareFlag = false;
      this.pushFlag = false;
      this.downloadTitle = "";
      this.shareTitle = "";
      this.pushTitle = "";
    },

    //分享
    // sharePic () {
    //   if (this.shareFlag) {
    //     if (this.shareTitle == "") {
    //       this.$message.error("请输入标题！");
    //     } else {
    //       this.comPic("share", this.shareTitle);
    //       this.shareFlag = false;
    //       this.$router.push("/shareAndPush/myShare");
    //     }
    //   }
    // },

    //打包下载
    async downloadPic () {
      if (this.downloadFlag) {
        if (this.downloadTitle == "") {
          this.$message.error("请输入标题！");
        } else {
          this.$confirm('请选择下载清晰度!', '提示', {
              distinguishCancelAndClose: true,
              confirmButtonText: '原图',
              cancelButtonText: '普通'
            }).then(() => {
              this.thumb = 'original'
              this.dialogVisibleMan = false
              this.comPic("download", this.downloadTitle);
              this.downloadFlag = false;
              this.$router.push("/shareAndPush/myDownload");
            }).catch(action  => {
              if(action === 'cancel'){
                this.thumb = 'small'
                this.dialogVisibleMan = false
                this.comPic("download", this.downloadTitle);
                this.downloadFlag = false;
                this.$router.push("/shareAndPush/myDownload");
              }
                     
            });
          
        }
      }
    },
    async pushSetStatus (val) {
      await setStatus(params)
    },

    handleCommand (command) {
      if (this.choosePicList.length == 0) {
        this.$message.warning('请选择图片！')
        return false;
      }
      if (command == 'a') {
        this.putInChoose()
        this.isChoosePic = true
      }
      if (command == 'b') {
        this.addInChoose()
        this.isChoosePic = true
      }
      if (command == 'c') {
        this.dialogVisibleChosePic = true
      }
    },

    //创建图集
    putInChoose () {
      // console.log(1)
      this.uploadMode = true
      this.libList = []
      this.listLibAsync();
      this.putinPicIds = this.choosePicList;
      this.dialogVisiblePutIn = true;
    },
    //加入图集
    addInChoose () {
      this.uploadMode = false
      this.libList = []
      this.listLibAsync();
      this.putinPicIds = this.choosePicList;
      this.dialogVisiblePutIn = true;
    },

    //创建图集
    putIn (e) {
      this.uploadMode = true
      this.libList = []
      this.listLibAsync();
      this.putinPicIds = e;
      this.activityArticleInfo = e
      this.isChoosePic = false
      this.dialogVisiblePutIn = true;
    },
    //加入图集
    addIn (e) {
      this.uploadMode = false
      this.libList = []
      this.listLibAsync();
      this.putinPicIds = e;
      this.activityArticleInfo = e
      this.isChoosePic = false
      this.dialogVisiblePutIn = true;
    },


    //选中图片确定并下载
    subPutDown(){
      this.$prompt('请输入下载标题', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(async ({ value }) => {
          if (this.uploadMode) {
            this.$refs["ruleForm"].validate(valid => {
              if (valid) {
                this.dialogLoading = true;
                let data = {
                  name: this.ruleForm.name,
                  desc: this.ruleForm.desc,
                  libId: this.ruleForm.region,
                  status: this.ruleForm.status,
                  sourceType: "0",
                  createUid: this.createUid,
                  indexpicId: "0"
                };
                this.addAtlasAsync(data,value);


              } else {
                return false;
              }
            });
          } else {
            if (!this.atlasId) {
              this.$message.warning('请选择图集！')
              return false
            }
            this.dialogLoading = true;


            if (!this.isChoosePic) {
              let e = this.putinPicIds;

              for (let i = 0; i < e.pictureInfo.length; i++) {
                let fId = await getPicture(e.pictureInfo[i].id)
                let picMsg = {
                  atlasId: this.atlasId,
                  fileId: fId.data.fileId,
                  libId: this.libId,
                  desc: "",
                  createUid: this.createUid,
                  tags: ''
                };
                let addPic = await addPicture(picMsg);

                if (addPic.status) {
                  if (i === e.pictureInfo.length - 1) {
                    this.$message.success("添加图片成功！");
                    this.dialogLoading = false;
                    this.dialogVisiblePutIn = false;
                    this.myselect = ''
                    this.atlasId = ''
                    this.libId = ''
                    let params = {
                      id: this.putinPicIds.id,
                      status: 1
                    }
                    await setStatus(params)

                    setTimeout(() => {
                      this.refresh()
                    }, 800);
                  }
                }
              }

            } else {
              let e = this.choosePicList;

              let picIds = []
              for (let i = 0; i < e.length; i++) {
                picIds.push(e[i].id)
              }

              let choosePicMsg = {
                createUid: this.createUid,
                packageType: 'download',
                pictureCount: picIds.length,
                pictureIds: picIds.join(','),
                title: value,
                downloadConfig: JSON.stringify({ 
                  thumb:'original',
                  pictureActivityId: this.activity == '不限' ? 0 : this.activity || 0,
                  pictureActivityArticleId: this.activityArticleInfo?this.activityArticleInfo.id:'',
                  websiteColumnId: this.activityArticleInfo?this.activityArticleInfo.websiteColumnId:'',
                  title: this.activityArticleInfo?this.activityArticleInfo.title:'',
                  createUserInfo: this.activityArticleInfo?this.activityArticleInfo.createUserInfo:'',
                }) || ''
              }

              this.addPicturePackageAsync(choosePicMsg)

              for (let i = 0; i < e.length; i++) {
                let picMsg = {
                  atlasId: this.atlasId,
                  fileId: e[i].fileId,
                  id: e[i].id,
                  libId: this.libId
                };
                let addPic = await updatePicture(picMsg);

                if (addPic.status) {
                  if (i === e.length - 1) {
                    this.$message.success("添加图片成功！");
                    this.choosePicList = []
                    this.setUserSettingAsync(this.createUid, 'choosePicList', { value: null })
                    this.refresh()
                    this.dialogLoading = false;
                    this.dialogVisiblePutIn = false;
                    this.myselect = ''
                    this.atlasId = ''
                    this.libId = ''
                    this.myAtlas = []
                    this.searchAtlasAsync({ pageSize: 20, page: 0, createUid: this.createUid })

                  }
                }
              }

            }

          }
          this.choosePicList = []
          this.setUserSettingAsync(this.createUid, 'choosePicList', { value: null })
        })
      

      
    },

    //入库中
    async subPutIn () {
      if (this.uploadMode) {
        this.$refs["ruleForm"].validate(valid => {
          if (valid) {
            this.dialogLoading = true;
            let data = {
              name: this.ruleForm.name,
              desc: this.ruleForm.desc,
              libId: this.ruleForm.region,
              status: this.ruleForm.status,
              sourceType: "0",
              createUid: this.createUid,
              indexpicId: "0"
            };
            this.addAtlasAsync(data);
          } else {
            return false;
          }
        });
      } else {
        if (!this.atlasId) {
          this.$message.warning('请选择图集！')
          return false
        }
        this.dialogLoading = true;


        if (!this.isChoosePic) {
          let e = this.putinPicIds;

          for (let i = 0; i < e.pictureInfo.length; i++) {
            let fId = await getPicture(e.pictureInfo[i].id)
            let picMsg = {
              atlasId: this.atlasId,
              fileId: fId.data.fileId,
              libId: this.libId,
              desc: "",
              createUid: this.createUid,
              tags: ''
            };
            let addPic = await addPicture(picMsg);

            if (addPic.status) {
              if (i === e.pictureInfo.length - 1) {
                this.$message.success("添加图片成功！");
                this.dialogLoading = false;
                this.dialogVisiblePutIn = false;
                this.myselect = ''
                this.atlasId = ''
                this.libId = ''
                let params = {
                  id: this.putinPicIds.id,
                  status: 1
                }
                await setStatus(params)

                setTimeout(() => {
                  this.refresh()
                }, 800);
              }
            }
          }

        } else {
          let e = this.choosePicList;

          for (let i = 0; i < e.length; i++) {
            let picMsg = {
              atlasId: this.atlasId,
              fileId: e[i].fileId,
              id: e[i].id,
              libId: this.libId
            };
            let addPic = await updatePicture(picMsg);

            if (addPic.status) {
              if (i === e.length - 1) {
                this.$message.success("添加图片成功！");
                this.choosePicList = []
                this.setUserSettingAsync(this.createUid, 'choosePicList', { value: null })
                this.refresh()
                this.dialogLoading = false;
                this.dialogVisiblePutIn = false;
                this.myselect = ''
                this.atlasId = ''
                this.libId = ''
                this.myAtlas = []
                this.searchAtlasAsync({ pageSize: 20, page: 0, createUid: this.createUid })

                // setTimeout(() => {
                //   this.$message.success('即将为您跳转到个人图集')
                //   setTimeout(() => {
                //     this.$router.push('/personpicindex')
                //   }, 1000);
                // }, 2000);
              }
            }
          }

        }

      }
      this.choosePicList = []
      this.setUserSettingAsync(this.createUid, 'choosePicList', { value: null })

    },

    //查看活动征稿的内容
    seeInf (e) {
      this.actInf = e;
      this.actInf.content = this.turn(this.actInf.content)
      this.actInf.content = this.turn1(this.actInf.content)
      this.dialogVisibleInf = true;
    },

    checkClicksh (id) {
      this.$confirm("确认审核通过吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.setCheckAsync({ id, isCheck: 1, message: '' });
        })
        .catch(e => { });
    },
    checkClickrefuse (item) {
      console.log(item);
      if (item.isCheck == 1) {
        for (let i = 0; i < item.pictureInfo.length; i++) {
          if (item.pictureInfo[i].isChoose) {
            this.$message.error('请取消选中的图片后再操作！')
            return
          }
        }
      }
      this.$prompt('拒绝理由：', '拒绝', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      }).then(({ value }) => {
        // console.log(value);
        if (value == null) {
          this.$message.error('请填写拒绝理由！')
          return
        } else {
          let id = item.id
          this.setCheckAsync({ id, isCheck: 2, message: value });
        }
      })
    },
    checkClickfs (id) {
      this.$confirm("确认撤回审核吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.setCheckAsync({ id, isCheck: 0, message: '' });
        })
        .catch(e => { });
    },

    //删除投稿活动
    deleteActArt (e) {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(event => {
          let params = {
            id: e.id,
            status: -99
          }
          this.setStatusAsync(params);
        })
        .catch(event => { });
    },

    handleCloseInf () {
      this.dialogVisibleInf = false;
    },
    handleClosePutIn () {
      // this.uploadMode = true
      this.dialogVisiblePutIn = false;
      this.$refs["ruleForm"].resetFields();
    },
    handleCloseMan () {
      this.dialogVisibleMan = false;
      this.handleClose();
    },

    //向右滚动
    actRight (i) {
      // this.scroll = 0
      let actimgwidth = this.$refs["actimg" + i][0].offsetWidth;
      let tablebgbodywidth = this.$refs["tablebgbody" + i][0].offsetWidth;
      let widthcha = tablebgbodywidth - actimgwidth;
      if (this.listPictureActivity[i].picScroll > widthcha) {
        this.listPictureActivity[i].picScroll += -90;
      }

      this.$refs["actimg" + i][0].style.transform =
        "translateX(" + this.listPictureActivity[i].picScroll + "px)";
      // console.log(this.scroll, this.listPictureActivity[i].picScroll);
    },

    //向左滚动
    actLeft (i) {
      // this.scroll = 0
      let actimgwidth = this.$refs["actimg" + i][0].offsetWidth;
      let tablebgbodywidth = this.$refs["tablebgbody" + i][0].offsetWidth;
      let widthcha = tablebgbodywidth - actimgwidth;
      if (this.listPictureActivity[i].picScroll !== 0) {
        this.listPictureActivity[i].picScroll += 90;
      }
      this.$refs["actimg" + i][0].style.transform =
        "translateX(" + this.listPictureActivity[i].picScroll + "px)";
      // console.log(this.scroll, this.listPictureActivity[i].picScroll);
    },

    //设置审核结果
    async setCheckAsync (val) {
      let { status, data, message, errors } = await setCheck(val);
      if (status) {
        this.$message.success("设置成功！");
        this.handleCurrentChange(this.currentPage);

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


    //删除投稿活动
    async setStatusAsync (val) {
      let { status, data, message, errors } = await setStatus(val);
      if (status) {
        this.$message.success("删除成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取征稿活动列表
    async listPictureActivityAsync (val) {
      let { status, data, message, pagination, errors } = await listPictureActivity(val);
      if (status) {
        this.activityList = []
        // this.activityList.push({
        //   value: 0,
        //   label: "不限"
        // });
        for (let i = 0; i < data.length; i++) {
          if (data[i].status === 1) {
            this.activityList.push({
              value: data[i].id,
              label: data[i].title
            });
          }

        }
        // if (this.activityList) {
        //   this.activity = this.activityList[0].value
        // } else {
        //   this.activity = '暂无'
        // }

        this.handleCurrentChange(this.currentPage);

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取图片库列表
    async listLibAsync () {
      let { status, data, message, errors } = await listLib();
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
            if (data[i].status === 1) {
              this.libList.push({
                value: data[i].id,
                label: data[i].name,
                children:[]
              });
            }

          }
        }

        for (let i = 0;i < this.libList.length;i++) {
          let flag = 0
          for (let j = 0; j < this.allowLib.length; j++) {
            if(this.allowLib[j].toString().indexOf('-') !== -1){
              if(this.libList[i].value == this.allowLib[j].split('-')[0]){
                flag++
                this.libList[i].children.push({
                  value: this.allowLib[j].split('-')[1],
                  label: ''
                })
              }
            }
            
          }
          if(flag == 0){
            delete this.libList[i].children
          }
        }

        for (let i = 0; i < this.libList.length; i++) {
          if(this.libList[i].hasOwnProperty('children')){
            if(this.libList[i].children.length > 0){
              for (let z = 0; z < this.libList[i].children.length; z++) {
                for (let j = 0; j < data.length; j++) {
                  if(data[j].id == this.libList[i].children[z].value){
                    this.libList[i].children[z].label = data[j].name
                  }
                  
                }
                
              }
              
            }
          }
          
          
        }


      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //获取图片邀约列表
    async listPictureNeedAsync () {
      let { status, data, message, pagination, errors } = await myPictureNeed();
      if (status) {
        this.picInviteList = data;

        if (data.length !== 0) {
          this.myform.name = this.picInviteList[0].title;
          this.myform.id = this.picInviteList[0].id;
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取允许的推送渠道
    async listAllowPushChannelAsync () {
      let { status, data, message, errors } = await listAllowPushChannel();
      if (status) {
        this.pushList = data;
        this.template = this.pushList[0].template;
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //增加图片包
    async addPicturePackageAsync (val) {
      let { status, data, message, errors } = await addPicturePackage(val);
      if (status) {
        this.$message.success("添加成功！");
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //创建图集
    async addAtlasAsync (val,value) {
      let arr = this.choosePicList
      let libArr = val.libId
      if(libArr.length >= 2){
        val.parentLibId = parseInt(libArr[0])
        val.libId = parseInt(libArr[1])
      }else{
        val.parentLibId = 0
        val.libId = parseInt(libArr[0])
      }
      let { status, data, message, errors } = await addAtlas(val);
      if (status) {
        this.atlasId = data.id;
        this.libId = data.libId;


        if (!this.isChoosePic) {
          let e = this.putinPicIds;

          for (let i = 0; i < e.pictureInfo.length; i++) {
            let fId = await getPicture(e.pictureInfo[i].id)
            let picMsg = {
              atlasId: data.id,
              fileId: fId.data.fileId,
              libId: data.libId,
              desc: "",
              createUid: this.createUid,
              tags: ''
            };
            let addPic = await addPicture(picMsg);

            if (addPic.status) {
              if (i === e.pictureInfo.length - 1) {
                this.$message.success("创建图集成功！");
                this.dialogLoading = false;
                this.dialogVisiblePutIn = false;
                let params = {
                  id: this.putinPicIds.id,
                  status: 1
                }
                await setStatus(params)
                this.handleCurrentChange(this.currentPage)
                this.refresh()
                this.$refs["ruleForm"].resetFields();
              }
            }
          }
        } else {
          let e = arr

          let picIds = []
          for (let i = 0; i < e.length; i++) {
            picIds.push(e[i].id)
          }

          let choosePicMsg = {
            createUid: this.createUid,
            packageType: 'download',
            pictureCount: picIds.length,
            pictureIds: picIds.join(','),
            title: value,
            downloadConfig: JSON.stringify({ 
              thumb:'original',
              pictureActivityId: this.activity == '不限' ? 0 : this.activity || 0,
              pictureActivityArticleId: this.activityArticleInfo?this.activityArticleInfo.id:'',
              websiteColumnId: this.activityArticleInfo?this.activityArticleInfo.websiteColumnId:'',
              title: this.activityArticleInfo?this.activityArticleInfo.title:'',
              createUserInfo: this.activityArticleInfo?this.activityArticleInfo.createUserInfo:'',
            }) || ''
          }
          this.addPicturePackageAsync(choosePicMsg)

          for (let i = 0; i < e.length; i++) {
            let picMsg = {
              atlasId: data.id,
              fileId: e[i].fileId,
              id: e[i].id,
              libId: data.id
            };
            let addPic = await updatePicture(picMsg);

            if (addPic.status) {
              if (i === e.length - 1) {
                this.$message.success("创建图集成功！");
                this.choosePicList = []
                this.handleCurrentChange(this.currentPage)
                this.dialogLoading = false;
                this.dialogVisiblePutIn = false;
                this.refresh()
                this.$refs["ruleForm"].resetFields();
              }
            }
          }
        }


      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.dialogLoading = false;
      }
    },

    //获取活动投稿列表
    async listPictureActivityArticleAsync (val) {
      this.isRefresh = true;
      let {
        status,
        data,
        message,
        pagination, errors
      } = await listPictureActivityArticles(val);
      if (status) {
        // this.totals= pagination.total
        this.listPictureActivity = data;
        // if (this.currentPage === 1) {
        //   this.listPictureActivity = data;
        // } else {
        //   for (let i = 0; i < data.length; i++) {
        //     this.listPictureActivity.push(data[i]);
        //   }
        // }

        this.total = pagination.total;
        for (let i = 0; i < this.listPictureActivity.length; i++) {
          console.log(this.listPictureActivity[i].websiteShowInfoList);
          if (this.listPictureActivity[i].websiteShowInfoList != null) {
            let altasPicId = this.listPictureActivity[i].pictureIds.split(',').sort()
            let publishedArr = []
            // for (let k = 0; k < altasPicId.length; k++) {
            for (let m = 0; m < this.listPictureActivity[i].websiteShowInfoList.length; m++) {
              let published = this.listPictureActivity[i].websiteShowInfoList[m].pictureIds.split(',').sort()
              // console.log(altasPicId, published);
              let tempArr = []
              for (let t = 0; t < altasPicId.length; t++) {
                for (let h = 0; h < published.length; h++) {
                  if (published[h] == altasPicId[t]) {
                    tempArr[t] = this.listPictureActivity[i].websiteShowInfoList[m].columnInfo.name
                    break;
                  }
                }
              }
              // console.log(tempArr);
              publishedArr.push(tempArr)
              // console.log(publishedArr);
            }
            let pubArr = []
            for (let mm = 0; mm < altasPicId.length; mm++) {
              let str = ''
              for (let ii = 0; ii < publishedArr.length; ii++) {
                if (publishedArr[ii][mm] != undefined) {
                  str += publishedArr[ii][mm] + ' '
                }
              }
              pubArr[mm] = str
            }
            this.listPictureActivity[i].publishedArr = pubArr
          }
          // console.log(this.listPictureActivity[i]);

          this.listPictureActivity[
            i
          ].pictureIdsArray = this.listPictureActivity[i].pictureIds.split(",");
          this.listPictureActivity[i].pictureInfo = [];
          this.listPictureActivity[i].picScroll = 0;

          this.listPictureActivity[i].isSelect = false;

          this.listPictureActivity[i].createAtMy = formatConversion(
            this.listPictureActivity[i].createAt.toString()
          );

          let pics = await getPictures({
            ids: this.listPictureActivity[i].pictureIds
          });

          this.listPictureActivity[i].pictureInfo = pics.data;

          for (
            let j = 0;
            j < this.listPictureActivity[i].pictureInfo.length;
            j++
          ) {
            this.listPictureActivity[i].pictureInfo[j].isChoose = false
            for (let z = 0; z < this.choosePicList.length; z++) {
              if (this.choosePicList[z].id == this.listPictureActivity[i].pictureInfo[j].id) {
                this.listPictureActivity[i].pictureInfo[j].isChoose = true
              }
            }

            if (this.listPictureActivity[i].pictureInfo[j].exif) {
              this.listPictureActivity[i].pictureInfo[j].exif = JSON.parse(this.listPictureActivity[i].pictureInfo[j].exif)
            }
            if (this.listPictureActivity[i].pictureInfo[j].fileInfo) {
              if (
                !this.listPictureActivity[i].pictureInfo[j].fileInfo.picThumbH160
              ) {
                this.listPictureActivity[i].pictureInfo[j].fileInfo.scr =
                  picPrefix +
                  this.listPictureActivity[i].pictureInfo[j].fileInfo.savepath;
                this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 =
                  picPrefix +
                  this.listPictureActivity[i].pictureInfo[j].fileInfo.savepath;
                this.listPictureActivity[i].pictureInfo[j].fileInfo.srcW1080 =
                  picPrefix +
                  this.listPictureActivity[i].pictureInfo[j].fileInfo.savepath;
              } else if (this.listPictureActivity[i].pictureInfo[j].fileInfo.picThumbH160 == 'ERROR') {
                this.listPictureActivity[i].pictureInfo[j].fileInfo.scr = require('@/assets/house/onloadpicerror.png')

                this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 = require('@/assets/house/onloadpicerror.png')

                this.listPictureActivity[i].pictureInfo[j].fileInfo.srcW1080 = require('@/assets/house/onloadpicerror.png')

              } else {
                this.listPictureActivity[i].pictureInfo[j].fileInfo.scr =
                  picPrefix +
                  this.listPictureActivity[i].pictureInfo[j].fileInfo
                    .picThumbH160;
                this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 =
                  picPrefix +
                  this.listPictureActivity[i].pictureInfo[j].fileInfo
                    .picThumbWh160;
                this.listPictureActivity[i].pictureInfo[j].fileInfo.srcW1080 =
                  picPrefix +
                  this.listPictureActivity[i].pictureInfo[j].fileInfo
                    .picThumbW1080;
              }
              //图片加载失败
              if (!this.listPictureActivity[i].pictureInfo[j].fileInfo) {
                this.listPictureActivity[i].pictureInfo[j].fileInfo.scr = require('@/assets/house/onloadpic.png')
                this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 = require('@/assets/house/onloadpic.png')
                this.listPictureActivity[i].pictureInfo[j].fileInfo.srcW1080 = require('@/assets/house/onloadpic.png')
              }
            } else {
              this.listPictureActivity[i].pictureInfo[j].fileInfo = {
                scr: '',
                Wh160: '',
                srcW1080: ''
              }
              this.listPictureActivity[i].pictureInfo[j].fileInfo.scr = require('@/assets/house/onloadpicerror.png')

              this.listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 = require('@/assets/house/onloadpicerror.png')

              this.listPictureActivity[i].pictureInfo[j].fileInfo.srcW1080 = require('@/assets/house/onloadpicerror.png')

            }


          }

          if (this.listPictureActivity[i].createUserInfo) {
            this.listPictureActivity[i].actUser = this.listPictureActivity[i].createUserInfo.name
          } else {
            this.listPictureActivity[i].actUser = '暂无'
          }
          if (this.listPictureActivity[i].activityInfo) {
            this.listPictureActivity[i].actName = this.listPictureActivity[i].activityInfo.title
          } else {
            this.listPictureActivity[i].actName = '暂无'
          }

          // if (this.listPictureActivity[i].pictureCount !== 0) {
          //   for (
          //     let j = 0;
          //     j < this.listPictureActivity[i].pictureIdsArray.length;
          //     j++
          //   ) {
          //     let picInfo = await getPicture(
          //       this.listPictureActivity[i].pictureIdsArray[j]
          //     );
          //     let fileInfo = await getFileInfoById(picInfo.data.fileId);

          //     let listPicAct = { ...fileInfo.data };

          //     if (!fileInfo.data.picThumbH160) {
          //       listPicAct.src = picPrefix + fileInfo.data.savepath;
          //       listPicAct.picThumbWh160 = picPrefix + fileInfo.data.savepath;
          //       listPicAct.srcW1080 = picPrefix + fileInfo.data.savepath;
          //     } else {
          //       listPicAct.src = picPrefix + fileInfo.data.picThumbH160;
          //       listPicAct.picThumbWh160 =
          //         picPrefix + fileInfo.data.picThumbWh160;
          //       listPicAct.srcW1080 = picPrefix + fileInfo.data.picThumbW1080;
          //     }

          //     this.listPictureActivity[i].pictureInfo.push(listPicAct);
          //   }
          // }
        }
        // console.log(this.listPictureActivity)

        this.isRefresh = false;
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false;
      }
      this.articlePicturesNumbersapi()
    },
    //获取个人图集
    async searchAtlasAsync (val) {
      let { status, data, message, errors } = await searchAtlas(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          this.myAtlas.push({
            name: '[' + (data[i].libInfo ? data[i].libInfo.name : '暂无') + '] ' + data[i].name,
            date: formatConversion(data[i].createAt.toString()),
            libId: data[i].libId,
            atlasId: data[i].id
          });

        }
        // this.myAtlasId = this.myAtlas[0].label;
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //设置选中图片
    async setUserSettingAsync (val, val2, data1) {
      let { status, data, message, errors } = await setUserSetting(val, val2, data1);
      if (status) {
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    // 获取选中图片
    async getUserSettingAsync (val, val2) {
      let { status, data, message, errors } = await getUserSetting(val, val2);
      if (status) {
        let choosePic = JSON.parse(data)
        console.log(JSON.parse(choosePic.value));
        if (choosePic) {
          if (choosePic.value && JSON.parse(choosePic.value).length > 0) {
            // this.choosePicList = JSON.parse(choosePic.value)
            let picIds = []
            for (let i = 0; i < choosePic.value.length; i++) {
              picIds.push(choosePic.value[i].id)
            }
            picIds = picIds.join(',');
            // console.log(picIds);
            let idsInfo = await getPictures({ ids: picIds });
            for (let j = 0; j < idsInfo.data.length; j++) {
              idsInfo.data[j].fileInfo.scr = this.picPrefix + idsInfo.data[j].fileInfo.picThumbH160
            }
            // console.log(idsInfo.data);
            this.choosePicList = idsInfo.data
          }
        }

        console.log(this.choosePicList)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //判断可见性是否有权限
    checkStatus () {
      let createLength = 0

      if (powersObj.createPrivateAtlas) {
        this.statusFlag = true
        this.ruleForm.status = '0'
      } else {
        createLength++
      }
      if (powersObj.createPublicAtlas) {
        this.statusFlag = true
        this.ruleForm.status = '1'
      } else {
        createLength++
      }

      if (createLength == 2) {
        this.isSave = true
        this.statusFlag = true
        this.$message.warning('请联系管理员添加可见性的权限！')
      }

      if (createLength == 0) {
        this.statusFlag = false
        this.ruleForm.status = '0'
      }
    },
  },
  created () {
    this.listWebsiteColumnAsync()
    this.listAllowPushChannelAsync();
    this.checkStatus()

    window.onresize = () => {
      if (!checkFull()) {
        // 退出全屏后要执行的动作
        // console.log("退出全屏")
        this.seeFull = false;
      }
    }
    // console.log(this.$route.query.status)
    if (this.$route.query.status == 0) {
      this.isCheck = 0
    }
    if (this.$route.query.status == 1) {
      this.isCheck = parseInt(this.$route.query.status) || 1
    }
    if (this.$route.query.status == 2) {
      this.isCheck = parseInt(this.$route.query.status) || 2
    }
    this.getUserSettingAsync(this.createUid, 'choosePicList')

    //获取屏幕的宽度来控制列表的间距
    this.displayResolution = document.documentElement.clientWidth;
    // if (powersObj.manageAllPictureActivity) {
    //   this.listPictureActivityAsync({ createUid: -1, pageSize: 100 });
    // } else if (powersObj.myPictureActivity) {
    //   this.listPictureActivityAsync({ createUid: 0, pageSize: 100 });
    // } else {
    //   this.$message.warning('获取活动列表失败！')
    // }

    this.searchAtlasAsync({ pageSize: 20, page: 0, createUid: this.createUid })


    // this.timeInt = setInterval(() => {
    //   this.handleCurrentChange(this.currentPage);
    // }, 180000);


    // console.log(this.listPictureActivity)
  },
  mounted () {
    // window.addEventListener("scroll", this.scrollPic);
  },
  destroyed () {
    //离开这个界面之后，删除，不然会有问题
    // window.removeEventListener("scroll", this.scrollPic);
  },
  beforeDestroy () {
    // 组件销毁前调用
    // clearTimeout(this.timeInt);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./columnCheck.scss";
@import "@/constants/elHeader.scss";
h4 {
  font-size: 18px;
}

// ::v-deep .el-select__caret:before {
//   content: "\e78f";
//   font-size: 16px;
//   color: black;
// }

.clearMar ::v-deep .el-dialog__body {
  padding: 0;
}
.ruku ::v-deep .el-dialog__body {
  padding: 0;
}

/*滚动条样式*/
::v-deep ::-webkit-scrollbar {
  width: 10px;
  /*height: 4px;*/
}
::v-deep ::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
::v-deep ::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}
.el-table ::v-deep .el-table__body tr td {
  cursor: pointer;
}
.el-table ::v-deep .el-table__body .current-row td {
  background-color: #929292 !important;
}
.el-table ::v-deep .el-table__body .current-row td .cell {
  color: #fff !important;
}
</style>
